import React, { useRef, useState, useEffect, forwardRef } from 'react';
import './CheckboxSelectionList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import logComponent from '../../common/logComponent';

const CheckboxSelectionList = forwardRef(function CheckboxSelectionList(props, ref) {
  const { initialSelection, items, itemKeyField, onSelect, columns, itemComponent: ItemComponent, itemsLoading, itemsError, singularItemTerm, pluralItemTerm, showDetail, reloadAction } = props;
  const [selectedItem, setSelectedItem] = useState(initialSelection ? initialSelection : null);

  if (logComponent('CheckboxSelectionList')) { console.debug('CheckboxSelectionList rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('CheckboxSelectionList')) { console.debug('CheckboxSelectionList onMount'); }
    focusFirstListItem();
  }, []);

  const focusFirstListItem = () => {
    if (logComponent('CheckboxSelectionList')) { console.debug('CheckboxSelectionList focusFirstListItem'); }
    if (ref.current) ref.current.focus();
  }

  const selectItem = (e) => {
    if (logComponent('CheckboxSelectionList')) { console.debug('CheckboxSelectionList selectItem'); }
    const { itemKey } = e.currentTarget.dataset;

    const newSelectedItem = items.find(item => item[itemKeyField] == itemKey);

    if (!newSelectedItem || (selectedItem &&
        newSelectedItem[itemKeyField] === selectedItem[itemKeyField])) return;

    setSelectedItem(newSelectedItem);

    if (onSelect) onSelect(newSelectedItem);
  }


  return (
    <div className="Checkbox-Selection-List">
      <span>Results</span>
      <table className="Checkbox-Selection-List__table">
        <thead className="Checkbox-Selection-List__thead">
          <tr>
            {
              columns.map(column => {
                return (
                  <th
                    key={column.heading}
                    className={'Checkbox-Selection-List__heading' +
                      (column.hideAt ? ' hide-at-' + column.hideAt : '')}
                    style={column.style}>
                      {column.heading}
                  </th>)
              }
              )
            }
          </tr>
        </thead>
        <tbody className="Checkbox-Selection-List__tbody">
          {
            (items && 
            !itemsLoading && !itemsError && items.length > 0) &&
            items.map((item, index) => {
              let itemProp = {};
              itemProp[singularItemTerm] = item;

              return (
                <tr
                  className="Checkbox-Selection-List__row"
                  data-item-key={item[itemKeyField]}
                  key={'tr' + item[itemKeyField]}
                  onClick={selectItem}
                  ref={index === 0 ? ref : null}>

                  <ItemComponent
                    {...itemProp}
                    key={'Row' + item[itemKeyField]}
                    showDetail={showDetail} />
                  <td className={'Checkbox-Selection-List__selection-indicator' +
                    (selectedItem && selectedItem[itemKeyField] == item[itemKeyField] ?
                    ' Checkbox-Selection-List__selection-indicator--selected' :
                    ' Checkbox-Selection-List__selection-indicator--deselected')}>
                    {
                      selectedItem && selectedItem[itemKeyField] == item[itemKeyField] ?
                        <FontAwesomeIcon className="Checkbox-Selection-List__selected" icon= {['far','check-square']} /> :
                        <FontAwesomeIcon className="Checkbox-Selection-List__unselected" icon={['far', 'square']} />
                    }
                  </td>

                </tr>

              )
            })
          }
        </tbody>
      </table>
      {
        !itemsLoading && !itemsError && items && items.length === 0 &&
        <p className="Checkbox-Selection-List__empty">No {pluralItemTerm} found...</p>
      }
      {
        itemsLoading &&
        <p className="Checkbox-Selection-List__loading">Loading {pluralItemTerm}...</p>
      }
      {
        !items &&
        (itemsLoading ?
        <ModuleLoadingStatus isLoading={itemsLoading} isError={itemsError} reloadAction={reloadAction} /> :
      <p className="Checkbox-Selection-List__instruction-message">To search users, please enter an email above.</p>)
      }
      
      {
        itemsError &&
        <div className="Checkbox-Selection-List__error">
          <p className="Checkbox-Selection-List__error-text">There was an error loading the {pluralItemTerm}.</p>
          <button
            className="Checkbox-Selection-List__reload"
            onClick={reloadAction}>
            Try Again
            </button>
        </div>
      }
    </div>
    );
});
export default CheckboxSelectionList;